import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MapHelperService } from "../../../../../services/map-helper.service";
import { LayerDTO } from "../../models/LayerDTO";
import { filter, Observable, Subscription, take } from "rxjs";
import { PanelExternalLayerService } from "../../services/Panel-External-Layer.service";
import { ToolCarsSelectorService } from "../../services/Tool-Cars-Selector.service";
import { LayerService } from "../../services/Layers.service";
import { EnumLayerSources } from "src/app/features/shared/helpers/enums/EnumLayerSources";
@Component({
  selector: "panel-external-layers",
  templateUrl: "./panel-external-layers.component.html",
  styleUrls: ["./panel-external-layers.component.css"],
  animations: [
    trigger("mostrarLista", [
      state("visible", style({ opacity: 1, height: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
    trigger("expandCollapseLayers", [
      state("expanded", style({ opacity: 1, height: "*" })),
      state("collapsed", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("expanded <=> collapsed", animate("350ms ease-in-out")),
    ]),
  ],
})
export class PanelExternalLayersComponent implements OnInit, OnDestroy {
  isInitializingLayers: boolean = false;
  listaCapasVisible: boolean = false;

  //Array con las posibles opcciones.
  //Si se ocupa hacerlo dinámico con los add-ons después, se puede
  $capas = new Array<LayerDTO>();
  suscription_GetListLayers: Subscription;
  suscription_GetLayerDataByNameGeoJSON: Subscription;
  // $capas = [
  //   { label: 'Geocercas', checked: false, capaId: "" } /*"layer-geofencesPolygons" este es el id que trataba de poner para manipularla en el map helper*/
  // ];

  $capasService: Observable<any>;
  subscription_GetGeofenceIndicator: Subscription;
  Subscription_GetMapMainSource: Subscription;

  constructor(
    private mapHelper: MapHelperService,
    public panelExternalLayerService: PanelExternalLayerService,
    public layerCatalogService: LayerService,
    public toolCarsSelectorService: ToolCarsSelectorService,
  ) {
    this.$capasService = this.panelExternalLayerService.getLayers();
    this.subscription_GetGeofenceIndicator = this.$capasService.subscribe((data)=>{
      this.$capas = data;
    });
  }

  ngOnInit(): void {
    this.Subscription_GetMapMainSource = this.mapHelper.mainSource$.pipe(
      filter(location => location && location.isMainSourceReady && location.isStyleReady)
    ).subscribe(location => {
      if (location && location.isMainSourceReady && location.isStyleReady && !this.isInitializingLayers) {
        this.GetListLayers();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
    if (this.suscription_GetLayerDataByNameGeoJSON)
      this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
    if (this.subscription_GetGeofenceIndicator)
      this.subscription_GetGeofenceIndicator.unsubscribe();
    if (this.Subscription_GetMapMainSource)
      this.Subscription_GetMapMainSource.unsubscribe();
  }

  GetListLayers() {
    this.isInitializingLayers = true;
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
    this.suscription_GetListLayers = this.layerCatalogService.GetListLayers(EnumLayerSources.External).subscribe((data) => {
      this.$capas = data.result as LayerDTO[];
      if (this.$capas != null && this.$capas.length != 0) {
        this.panelExternalLayerService.capas = this.$capas;
        this.$capas.forEach((element) => {
          this.panelExternalLayerService.createMapLayer(element);
        });
        this.mapHelper.CreateCustomerLayersHoverEvent(this.$capas);
        
        this.layerCatalogService.isExternalLayersButtonDisabled = false;
      }else{
        this.panelExternalLayerService.capas = [];
        this.layerCatalogService.isExternalLayersButtonDisabled = true;
      }
      this.isInitializingLayers = false;
    });
  }

  onClickListaCapas() {
    this.toolCarsSelectorService.isCarSelectionToolVisible = false;
    this.layerCatalogService.isInternalLayersVisible = false;
    this.layerCatalogService.isMapLayersVisible = false;
    this.layerCatalogService.isExternalLayersVisible = !this.layerCatalogService.isExternalLayersVisible;
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(nameLayer: any) {
    this.panelExternalLayerService.onToggleLayer(nameLayer);
  }

  ClosePanel() {
    this.layerCatalogService.isExternalLayersVisible = false;
  }

  toggleExternalLayers() {
    this.panelExternalLayerService.isExternalLayersExpanded = !this.panelExternalLayerService.isExternalLayersExpanded;
  }

  onExpandCollapseStart(event: any) {
    this.panelExternalLayerService.isExpandCollapseAnimating = true;
  }

  onExpandCollapseDone(event: any) {
    this.panelExternalLayerService.isExpandCollapseAnimating = false;
  }

}
